import { useCallback, useEffect, useState } from "react";
import { EPaymentIframes } from "../../interface/IPayment";
import { useForm } from "react-hook-form";
import { rangePriceValue } from "@utils/formControl";
import { centsToPrice, priceToCents } from "itsf-ui-common";

interface IParams {
    amountToPay: number;
    getCurrentBalance: () => void;
    setOpenedIframe(openedIframe?: EPaymentIframes): void;
    getPayerDetails(): void;
}

export const usePaymentBalanceIframe = (props: IParams) => {
    const { amountToPay, getCurrentBalance, setOpenedIframe, getPayerDetails } = props;

    const [amountToSend, setAmountToSend] = useState<number>();

    // Amount props is always negative. Sign is reversed for better comprehension
    const positiveAmount = parseFloat(centsToPrice(amountToPay * -1));
    const handleRangePriceValue = rangePriceValue(0.02, positiveAmount);

    const formMethods = useForm<{ balance: string }>({ defaultValues: { balance: "" }, shouldUnregister: false });
    const { setValue, handleSubmit, watch } = formMethods;

    const balance = watch("balance");

    const successCallback = useCallback(() => {
        setOpenedIframe();
        getCurrentBalance();
        getPayerDetails();
    }, [getCurrentBalance, getPayerDetails, setOpenedIframe]);

    useEffect(() => {
        setValue("balance", positiveAmount.toFixed(2).toString());
    }, [positiveAmount, setValue]);

    useEffect(() => {
        if (balance) {
            let amount = balance;
            if (balance.endsWith(".")) {
                amount = balance.replace(".", "");
            }
            setAmountToSend(priceToCents(amount));
        }
    }, [balance]);

    const loadPaymentIframe = handleSubmit(() => {
        setOpenedIframe(EPaymentIframes.BALANCE);
    });

    return {
        amountToSend,
        formMethods,
        handleRangePriceValue,
        loadPaymentIframe,
        successCallback,
    };
};
